const appNameCache = new Map();

export const appNameCacheUtils = {
  get(appId) {
    if (!appId) return null;
    return appNameCache.get(String(appId)) || null;
  },
  set(appId, appName) {
    if (!appId || !appName) return;
    appNameCache.set(String(appId), String(appName));
  },
  has(appId) {
    if (!appId) return false;
    return appNameCache.has(String(appId));
  },
  clear(appId) {
    if (!appId) return;
    appNameCache.delete(String(appId));
  },
};
